import { Route, Routes } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { withAuth } from '@verantos-dev/core-auth';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { DatasetDelivery } from '@verantos-dev/feature-dataset-delivery';

const APP_ID = EvidencePlatformSidebarAppID.dataAdministration;

export const DataAdminUiRoutes = () => {
  useAppId(APP_ID);
  return (
    <Routes>
      <Route path="dataset-delivery" element={<DatasetDelivery />} />
    </Routes>
  );
};

export default withAuth(DataAdminUiRoutes, APP_ID);
